import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

// @ts-ignore
import WatchVideoButton from '@/components/Billing/WatchVideoButton.vue';
import { sanitizeHtml } from '@/utils/helpers';

interface Props {
	title: string;
	videoUrl?: string;
	subTitle?: string;
	learnMoreLink?: string;
	showComparePlans?: boolean;
	howItWorksExplanations: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingSectionHeader',
  props: {
    title: null,
    videoUrl: null,
    subTitle: null,
    learnMoreLink: null,
    showComparePlans: { type: Boolean, default: true },
    howItWorksExplanations: null
  },
  setup(__props: any) {


const isOpen = ref(false);

return { __sfc: true,isOpen, WatchVideoButton, sanitizeHtml }
}

})